const aboutData = {

hero: {
title: "About CarZone",
subtitle: "Your trusted platform to buy and sell used cars"
},

company: {
heading: "ABOUT CARZONE",
title: "Fastest growing platform for buying and selling cars",
description:
"CarZone connects buyers and sellers across India. We help users find the perfect used car with verified listings, transparent pricing and trusted dealers.",
features: [
"Verified car listings",
"Easy car selling process",
"Affordable price options",
"Trusted dealers & buyers"
]
},

/* FEATURES SECTION */

features: {
title: "Why Choose CarsInfinity",
description:
"CarsInfinity makes buying and selling used cars simple, safe, and transparent. Our platform connects buyers with trusted agents and verified sellers to ensure the best car deals.",

list: [
{
id:1,
icon:"🚗",
title:"Trusted Agents",
desc:"Browse thousands of verified used cars across multiple brands."
},
{
id:2,
icon:"💰",
title:"Best Price Deals",
desc:"Compare listings and find the best car prices in the market."
},
{
id:3,
icon:"🔒",
title:"Secure Transactions",
desc:"Trusted sellers and safe communication between buyers and dealers."
},
{
id:4,
icon:"⚡",
title:"Fast Buying Process",
desc:"Quickly browse, contact sellers, and finalize your car purchase."
}
]

},

/* STATS */

stats: [
{ id:1, value:"15K+", label:"Cars Sold" },
{ id:2, value:"8K+", label:"Happy Customers" },
{ id:3, value:"500+", label:"Trusted Dealers" },
{ id:4, value:"20+", label:"Cities Covered" }
],

/* CTA */

cta:{
title:"Find Your Dream Car Today",
description:
"Browse thousands of verified cars from trusted dealers and agents. Compare prices and drive home your perfect car today.",
button:"View Cars"
}

};

export default aboutData;